import { useIntl } from 'react-intl';
import { OrderSummary } from './types';
import { getOrderStatusNotes } from './utils';
import * as Styles from './Orders.css';

// Status label with its hints: days left for a pending decision and the
// order a renewal replaces.
const OrderStatusCell = ({
  order,
}: {
  order: Pick<
    OrderSummary,
    'status' | 'decisionDeadline' | 'predecessorOrderNumber'
  >;
}) => {
  const intl = useIntl();
  return (
    <>
      {intl.formatMessage({ id: `ORDERS.STATUS.${order.status}` })}
      {getOrderStatusNotes(order).map(({ id, values }) => (
        <Styles.CellNote key={id}>
          {intl.formatMessage({ id }, values)}
        </Styles.CellNote>
      ))}
    </>
  );
};

export default OrderStatusCell;
